import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  ...stateAbstract,
  certificatesCount: null,
  certificatesList: [],
  activitiesCount: null,
  activitiesList: [],
  billerconnectionsCount: 0,
  billerconnectionsDetail: {},
  billerconnectionsList: [],
  cafsCount: null,
  cafsDetail: {},
  cafsList: [],
  foliosCount: null,
  foliosList: [],
  foliosDetail: {},
  sequencesDetail: {},
  sequencesCount: null,
  sequencesList: [],
  supplierresponsesList: [],
  supplierresponsesCount: null,
  swapsDetail: {},
  swapsCount: null,
  swapsList: []
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
